import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue";
import { ref, computed, watch, nextTick, useTemplateRef } from 'vue';
import { ValidationProvider, ValidationErrors } from '@/components/ui/validate-form';
import BaseDropdown from '@/components/base-dropdown/base-dropdown.vue';
import BaseModal from '@/components/base-modal/base-modal.vue';
import { PromoCodeAPI } from '@/api/promo-code';
import { ValidationField } from 'vue-validate-form';
import { trlMessage } from '@/services/i18n';
import { UiButton, UiButtonLink, UiInput } from '@huntflow/ui';
const __default__ = {
    name: 'PromoCode'
};
export default /*@__PURE__*/ _defineComponent({
    ...__default__,
    props: {
        eventId: { default: '' },
        tariffId: { default: null },
        promoCode: { default: '' },
        editable: { type: Boolean, default: true }
    },
    emits: ["set-code"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const code = ref('');
        const loading = ref(false);
        const defaultValues = ref({ code: '' });
        const isInvalid = ref(false);
        const showModal = ref(false);
        // Флаг, что мы проверили валидность кода при вводе.
        // Нужен, чтобы знать, проверят ли валидность при заходе на страеицу с промо-кодом
        const isCodeChecked = ref(false);
        const promo = useTemplateRef('promo');
        const isShowingRemoveBtn = computed(() => __props.editable && __props.promoCode);
        const isCodeEmpty = computed(() => !code.value.toString().length);
        const title = computed(() => trlMessage('promo.code.title', { code: __props.promoCode.toString().toUpperCase() }));
        watch(() => __props.promoCode, (value) => {
            if (!__props.editable) {
                return;
            }
            if (!isCodeChecked.value && value && __props.tariffId != null) {
                PromoCodeAPI.fetchCodeInfo(__props.eventId, __props.tariffId, value).catch(() => {
                    showModal.value = true;
                });
            }
        });
        function handleCancel(onToggle) {
            code.value = '';
            isInvalid.value = false;
            onToggle();
        }
        function handleCheckCode({ event, error, onToggle }) {
            const { setError } = error;
            code.value = event.code;
            loading.value = true;
            PromoCodeAPI.fetchCodeInfo(__props.eventId, __props.tariffId, event.code)
                .then((resp) => {
                code.value = '';
                emit('set-code', resp);
                onToggle();
                isCodeChecked.value = true;
            })
                .catch((err) => {
                const errors = err.response?.data?.errors;
                if (errors && errors.length) {
                    errors.forEach((error) => {
                        setError('code', {
                            message: trlMessage(error?.detail ?? 'promo.code.invalid'),
                            type: 'code'
                        });
                    });
                }
                isInvalid.value = true;
            })
                .finally(() => {
                loading.value = false;
            });
        }
        function updateField(val) {
            isInvalid.value = false;
            code.value = val.code;
        }
        function handleRemove() {
            emit('set-code', {});
        }
        function handleHideModal() {
            showModal.value = false;
            handleRemove();
        }
        function handleShowInput(toggle) {
            toggle();
            nextTick(() => {
                promo.value?.focus();
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(_ctx.$style.promoWrapper)
            }, [
                (__props.promoCode)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass(_ctx.$style.title)
                    }, _toDisplayString(title.value), 3))
                    : (__props.editable)
                        ? (_openBlock(), _createBlock(BaseDropdown, { key: 1 }, {
                            default: _withCtx(({ onToggle }) => [
                                _createVNode(_unref(UiButtonLink), {
                                    onClick: ($event) => (handleShowInput(onToggle))
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(trlMessage)('promo.code.input')), 1)
                                    ]),
                                    _: 1
                                }, 8, ["onClick"])
                            ]),
                            menu: _withCtx(({ onToggle }) => [
                                _createVNode(_unref(ValidationProvider), {
                                    "default-values": defaultValues.value,
                                    onSubmit: (event, error) => handleCheckCode({ event, error, onToggle }),
                                    onChange: updateField
                                }, {
                                    default: _withCtx(({ handleSubmit }) => [
                                        _createElementVNode("div", null, [
                                            _createVNode(_unref(ValidationField), { name: "code" }, {
                                                default: _withCtx(({ id, modelValue, name, onChange }) => [
                                                    _createVNode(_unref(UiInput), {
                                                        ref_key: "promo",
                                                        ref: promo,
                                                        id: id,
                                                        "model-value": modelValue,
                                                        class: _normalizeClass(_ctx.$style.inputWrapper),
                                                        name: name,
                                                        error: isInvalid.value,
                                                        "onUpdate:modelValue": onChange,
                                                        onKeyup: _withKeys(_withModifiers(handleSubmit, ["stop"]), ["enter"])
                                                    }, null, 8, ["id", "model-value", "class", "name", "error", "onUpdate:modelValue", "onKeyup"]),
                                                    _createElementVNode("div", {
                                                        class: _normalizeClass(_ctx.$style.error)
                                                    }, [
                                                        _createVNode(_unref(ValidationErrors), { name: "code" })
                                                    ], 2)
                                                ]),
                                                _: 2
                                            }, 1024),
                                            _createElementVNode("div", {
                                                class: _normalizeClass(_ctx.$style.btnGroup)
                                            }, [
                                                _createVNode(_unref(UiButton), {
                                                    loading: loading.value,
                                                    disabled: isCodeEmpty.value,
                                                    onClick: handleSubmit
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_unref(trlMessage)('button.apply')), 1)
                                                    ]),
                                                    _: 1
                                                }, 8, ["loading", "disabled", "onClick"]),
                                                _createVNode(_unref(UiButton), {
                                                    type: "secondary",
                                                    onClick: ($event) => (handleCancel(onToggle))
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_unref(trlMessage)('button.cancel')), 1)
                                                    ]),
                                                    _: 1
                                                }, 8, ["onClick"])
                                            ], 2)
                                        ])
                                    ]),
                                    _: 2
                                }, 1032, ["default-values", "onSubmit"])
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                (isShowingRemoveBtn.value)
                    ? (_openBlock(), _createBlock(_unref(UiButton), {
                        key: 2,
                        type: "text-secondary",
                        "icon-before": "trash",
                        onClick: handleRemove
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(trlMessage)('button.remove')), 1)
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true),
                _createVNode(BaseModal, {
                    show: showModal.value,
                    onHide: handleHideModal
                }, {
                    content: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(trlMessage)('promo.code.expired')), 1)
                    ]),
                    footer: _withCtx(() => [
                        _createVNode(_unref(UiButton), {
                            class: _normalizeClass(_ctx.$style.continueBtn),
                            onClick: handleHideModal
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(trlMessage)('promo.code.expired.continue')), 1)
                            ]),
                            _: 1
                        }, 8, ["class"])
                    ]),
                    _: 1
                }, 8, ["show"])
            ], 2));
        };
    }
});
